import { BAILocale } from '.';
import el_GR from 'antd/es/locale/el_GR';

const localeValue: BAILocale = {
  lang: 'el',
  antdLocale: el_GR,
};

export default localeValue;
